function pickBasePrice(price: Record<string, any> | null | undefined) {
  if (!price) return null;

  const candidates = [
    "Base Price",
    "basePrice",
    "BasePrice",
    "Price",
    "price",
    "Amount",
    "amount",
  ];

  for (const key of candidates) {
    if (price[key] !== undefined && price[key] !== null && price[key] !== "") {
      return price[key];
    }
  }

  return null;
}

function normalizeSelectedValue(value: unknown) {
  if (value === undefined || value === null) return null;

  const raw = String(value).trim();
  if (!raw) return null;

  const numberLike = raw.replace(/,/g, "");
  if (/^-?\d+(\.\d+)?$/.test(numberLike)) {
    return Number(numberLike);
  }

  return raw;
}

export function buildLeadPayload(lead: any, price: any) {
  return {
    lead: {
      source: "eden-demo",
      createdAt: new Date().toISOString(),
    },
    customer: {
      zipCode: normalizeSelectedValue(lead.zipCode),
      homeType: normalizeSelectedValue(lead.homeType),
      squareFeet: normalizeSelectedValue(lead.squareFeet),
      stories: normalizeSelectedValue(lead.stories),
      yearBuilt: normalizeSelectedValue(lead.yearBuilt),
      ownership: normalizeSelectedValue(lead.ownership),
      address: {
        street: normalizeSelectedValue(lead.addressStreet),
        city: normalizeSelectedValue(lead.addressCity),
        state: normalizeSelectedValue(lead.addressState),
        zip: normalizeSelectedValue(lead.addressZip),
      },
    },
    contact: {
      firstName: normalizeSelectedValue(lead.contactFirstName),
      lastName: normalizeSelectedValue(lead.contactLastName),
      email: normalizeSelectedValue(lead.contactEmail),
      phone: normalizeSelectedValue(lead.contactPhone),
    },
    currentSystem: {
      acTonnage: normalizeSelectedValue(lead.currentACtonnage),
      seerRating: normalizeSelectedValue(lead.assumedSeerRating),
    },
    desiredSystem: {
      systemType: normalizeSelectedValue(lead.desiredSystemType),
      fuelType: normalizeSelectedValue(lead.desiredFuelType),
    },
    pricing: {
      basePrice: pickBasePrice(price),
      currency: "USD",
    },
  };
}
